import { createApp } from 'vue'
import Odds from "./Odds.vue";

const app = createApp(Odds);

app.mount('#main');
